import { HasReachLimit } from '@/api';
import { GetSceneParamsType, PlatformType } from './type';

/**
 * 是否超限
*/
export function isOutLimit(sceneParams: GetSceneParamsType) {
  return sceneParams.platform === PlatformType.MOBILE_OUTSIDE_WX
    && sceneParams.hasReachLimit !== HasReachLimit.IN_LIMIT;
}
